import logo from "@/logo.svg";

export function HeroHeader() {
  return (
    <header className="w-full max-w-5xl mx-auto pt-20 pb-12 px-6 text-center">
      <h1 className="flex items-end justify-center text-5xl md:text-6xl font-extrabold tracking-tight mb-4">
        <img src={logo} alt="Proxdav Logo" className="w-15 h-15 relative" />
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#5776F6] to-cyan-500 relative -left-1">
          rox
        </span>
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-500">
          dav
        </span>
      </h1>

      <div className="flex items-center justify-center gap-2 mb-8 animate-in fade-in slide-in-from-bottom-2 fill-mode-both duration-1000">
        <div className="flex items-center px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-900/50">
          <span className="text-sm font-semibold text-blue-600 dark:text-blue-400">
            Proxy
          </span>
        </div>
        <span className="text-neutral-300 dark:text-neutral-700 font-medium">
          +
        </span>
        <div className="flex items-center px-3 py-1 rounded-full bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-900/50">
          <span className="text-sm font-semibold text-purple-600 dark:text-purple-400">
            Dev
          </span>
        </div>
      </div>

      <p className="text-xl md:text-2xl text-neutral-600 dark:text-neutral-300 max-w-3xl mx-auto font-medium leading-relaxed">
        现代化桌面端代理管理与抓包工具
      </p>
      <p className="mt-4 text-lg text-neutral-500 dark:text-neutral-400 max-w-2xl mx-auto">
        集成了系统代理管理、MITM 流量拦截与请求重写。
        <br className="hidden md:block" />
        为开发者提供轻量且强大的网络调试能力。
      </p>
    </header>
  );
}
